document.addEventListener("DOMContentLoaded", function () {
  const breadcrumbs = document.querySelector(".breadcrumbs");
  const searchTermLink = document.querySelector(".search-term-link");
  let scrollTimeout;
  let isScrolling = false;
  let hasScrolled = false;

  function toggleBreadcrumbVisibility(visible) {
    breadcrumbs.style.opacity = visible ? "1" : "0";
    breadcrumbs.style.pointerEvents = visible ? "auto" : "none";
  }

  if (searchTermLink) {
    searchTermLink.addEventListener("click", (e) => {
      e.preventDefault();

      // Open menu
      const menuButton = document.querySelector(".header_left");
      menuButton.click();

      // Wait for menu to open, then click search
      setTimeout(() => {
        const searchBtn = document.querySelector(".search_btn");
        if (searchBtn) {
          searchBtn.click();
        }
      }, 300);
    });
  }

  window.addEventListener(
    "scroll",
    function () {
      // Add transition only after first scroll
      if (!hasScrolled) {
        hasScrolled = true;
        breadcrumbs.style.transition = "opacity 0.7s ease-in-out";
      }

      if (!isScrolling) {
        isScrolling = true;
        toggleBreadcrumbVisibility(false);
      }

      clearTimeout(scrollTimeout);

      scrollTimeout = setTimeout(function () {
        isScrolling = false;
        toggleBreadcrumbVisibility(true);
      }, 750);
    },
    { passive: true }
  );

  //Product Click
  function getCurrentCollectionFromUrl() {
    const pathParts = window.location.pathname.split("/");
    const collectionsIndex = pathParts.indexOf("collections");

    if (collectionsIndex !== -1 && pathParts[collectionsIndex + 1]) {
      // Get collection name and format it (e.g., "dresses" -> "Dresses")
      const collectionName = pathParts[collectionsIndex + 1];
      const formattedName = collectionName
        .split("-")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(" ");

      return {
        title: formattedName,
        url: `/collections/${collectionName}`,
      };
    }

    return null;
  }

  function handleProductClicks() {
    const productLinks = document.querySelectorAll(
      ".collection-grid-item__link"
    );

    // Get collection info from current URL
    const collectionData = getCurrentCollectionFromUrl();

    if (collectionData) {
      console.log("Found collection from URL:", collectionData);

      productLinks.forEach((link) => {
        link.addEventListener("click", function (e) {
          // Store collection data before navigation
          sessionStorage.setItem(
            "lastCollection",
            JSON.stringify(collectionData)
          );
          console.log("Stored collection data:", collectionData);
        });
      });
    }
  }

  function updateBreadcrumb() {
    try {
      // First try to get collection from URL
      const urlCollection = getCurrentCollectionFromUrl();

      // If not found in URL, try stored collection
      const storedCollection = sessionStorage.getItem("lastCollection");
      console.log("URL collection:", urlCollection);
      console.log("Stored collection:", storedCollection);

      // Use URL collection if available, otherwise use stored
      const collectionData =
        urlCollection ||
        (storedCollection ? JSON.parse(storedCollection) : null);

      if (collectionData) {
        const collectionBreadcrumb = document.getElementById(
          "collection-breadcrumb"
        );
        if (collectionBreadcrumb) {
          collectionBreadcrumb.innerHTML = `<a href="${collectionData.url}">${collectionData.title}</a>:`;
        }
      }
    } catch (error) {
      console.error("Error updating breadcrumb:", error);
    }
  }

  // Initialize handlers
  if (document.querySelector(".collection-grid")) {
    console.log("Setting up product click handlers");
    handleProductClicks();
  }

  if (window.location.pathname.includes("/products/")) {
    console.log("Updating breadcrumb on product page");
    updateBreadcrumb();
  }
  const shopMenuLink = document.querySelector(".shop-menu-link");
  if (shopMenuLink) {
    shopMenuLink.addEventListener("click", (e) => {
      e.preventDefault();

      // Find and click the menu button
      const menuButton = document.querySelector(".header_left");
      if (menuButton) {
        menuButton.click();
      }
    });
  }
});
